import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ENVIRONMENT } from '@cfp/core';
import { Alert, Button, FormGroupComponent, InputText, Link, ValidationFeedback } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordService } from 'csr-login-app';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LoginMessages } from '../login-messages';

@Component({
  selector: 'cfp-forgot-password-modal',
  templateUrl: './forgot-password-modal.html',
  imports: [
    LoginMessages,
    TranslateModule,
    ReactiveFormsModule,
    Button,
    ValidationFeedback,
    InputText,
    FormGroupComponent,
    Alert,
    Link
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordModal implements OnInit {
  public forceSsoWhenEmailContains?: string;
  public ssoLoginUrl?: string;

  protected readonly isLoading = signal(false);
  protected readonly successMessages = signal<string[]>([]);
  protected readonly warningMessages = signal<string[]>([]);
  protected readonly errorMessages = signal<string[]>([]);
  protected readonly shouldLoginUsingSsoOnly = signal(false);

  protected form: FormGroup;

  private readonly environment = inject(ENVIRONMENT);
  private readonly formBuilder = inject(FormBuilder);
  private readonly bsModalRef = inject(BsModalRef);
  private readonly passwordService = inject(PasswordService);

  public ngOnInit(): void {
    const group = {
      username: ['', Validators.required]
    };

    this.form = this.formBuilder.group(group);

    const forceSsoWhenEmailContains = this.forceSsoWhenEmailContains;
    if (forceSsoWhenEmailContains) {
      this.form.controls['username'].valueChanges.subscribe((value: string) => {
        this.shouldLoginUsingSsoOnly.set(value?.indexOf(forceSsoWhenEmailContains) >= 0);
        if (this.shouldLoginUsingSsoOnly()) {
          document.getElementById('loginSso')?.focus();
        }
      });
    }
  }

  protected isFieldValid(field: string): boolean {
    return this.form.get(field)?.valid ?? false;
  }

  protected hide(): void {
    this.bsModalRef.hide();
  }

  protected submitForm(): void {
    this.isLoading.set(true);

    this.passwordService
      .v2PasswordForgotpasswordPost({
        username: this.form.value.username,
        environmentCode: this.environment.environmentCode.dto
      })
      .subscribe({
        next: () => {
          this.isLoading.set(false);
          this.successMessages.set(['login.success.requestPasswordReset']);
        },
        error: () => {
          this.isLoading.set(false);
        }
      });
  }
}
